export enum FileExtension {
  Png = '.png',
  Jpg = '.jpg',
  Jpeg = '.jpeg',
  Csv = '.csv',
  Bin = '.bin',
  Fup = '.fup',
  Keb = '.keb',
  Tar = '.tar',
  Zip = '.zip',
  Pdf = '.pdf',
}

export const PNG = [FileExtension.Png];
export const JPG = [FileExtension.Jpeg, FileExtension.Jpg];
export const CSV = [FileExtension.Csv];
export const BIN = [FileExtension.Bin];
export const FUP = [FileExtension.Fup];
export const KEB = [FileExtension.Keb];
export const TAR = [FileExtension.Tar];
export const ZIP = [FileExtension.Zip];
export const PDF = [FileExtension.Pdf];
